module.exports = __webpack_public_path__ + "img/px.b5896a91.jpg";